import Keycloak from "keycloak-js";
import { SELECTED_PROJECT } from "../configuration";
import { getEnvType } from "../helpers";

// const envType = getEnvType(); // Ensure this is stable
const keycloak = new Keycloak({
  clientId: SELECTED_PROJECT,
  realm: `${SELECTED_PROJECT}-marketplace`,
  // clientId: envType === "dev" ? "alicia" : SELECTED_PROJECT,
  // realm: envType === "dev" ? "alicia-realm" : `${SELECTED_PROJECT}-marketplace`,
  // url:
  //   envType === "dev"
  //     ? "http://localhost:8081/"
  //     : `https://keycloak.${SELECTED_PROJECT}.rid-intrasoft.eu`,
  url: `https://keycloak.${SELECTED_PROJECT}.rid-intrasoft.eu`,
});

export default keycloak;
